import React from 'react';
import { AccordionItem } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import 'github-markdown-css/github-markdown.css';
import { markdownComponents as baseMarkdownComponents, MARKDOWN_CONTENT_STYLE } from '../utils/markdownRenderUtils';

// Override th to keep AISummaryAccordion design (bg-gray-50, break-words, scope)
const markdownComponents = {
  ...baseMarkdownComponents,
  th: ({ node, children, ...props }: any) => (
    <th className="border border-default-300 px-3 py-2 text-left font-semibold bg-content2 break-words" style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }} scope="col" {...props} title={typeof children === 'string' ? children : String(children)}>
      {children}
    </th>
  ),
};

// Reusable markdown content renderer component
export const MarkdownContent: React.FC<{ content: string }> = ({ content }) => {
    return (
        <div className="bg-content2 rounded-lg p-2">
            <div className="text-sm text-default-700 prose prose-sm max-w-none markdown-body overflow-x-auto"
                style={MARKDOWN_CONTENT_STYLE}>
                <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
                    {content?.replace(/\n/g, '  \n')}
                </ReactMarkdown>
            </div>
        </div>
    );
};

export interface AISummaryAccordionProps {
    aiSummary: string;
    className?: string;
}

export const AISummaryAccordion: React.FC<AISummaryAccordionProps> = ({
    aiSummary,
    className = 'mb-3'
}) => {
    return (
        <AccordionItem
            key="ai-summary"
            aria-label="AI Summary"
            title={
                <div className="flex items-center gap-3">
                    <Icon icon="mdi:sparkles" className="text-pink-600" style={{ width: '18px', height: '18px', flexShrink: 0 }} />
                    <div>
                        <div className="renderer-text-primary">AI Summary</div>
                        <div className="renderer-text-secondary">AI-generated analysis overview</div>
                    </div>
                </div>
            }
            className={className}
        >
            <div className="pt-1 pb-2">
                <div className="bg-content2 rounded-lg p-2">
                    <div className="text-sm text-default-700 prose prose-sm max-w-none markdown-body overflow-x-auto"
                        style={MARKDOWN_CONTENT_STYLE}>
                        <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
                            {aiSummary?.replace(/\n/g, '  \n')}
                        </ReactMarkdown>
                    </div>
                </div>
            </div>
        </AccordionItem>
    );
};
